import React, { useRef, useEffect } from "react";
import Footer from "../components/Footer";
import SubHeader from "../components/SubHeader";

function Peakfamily() {
  const images = [
    "/assets/images/rooms/peakfamily/1.webp?v=20260924",
    "/assets/images/rooms/peakfamily/2.webp?v=20260924",
    "/assets/images/rooms/peakfamily/3.webp?v=20260924",
    "/assets/images/rooms/peakfamily/4.webp?v=20260924",
    "/assets/images/rooms/peakfamily/5.webp?v=20260924",
  ];
  const galleryRef = useRef(null);

  useEffect(() => {
    const gallery = galleryRef.current;
    if (!gallery) return;
    const imageCount = images.length;
    const visibleCount = 4;
    let currentIndex = 0;
    const slideInterval = 5000; // 5 seconds

    const slide = () => {
      const itemWidth = gallery.offsetWidth / visibleCount;
      currentIndex = (currentIndex + 1) % Math.max(1, imageCount - visibleCount + 1);
      gallery.scrollTo({
        left: currentIndex * itemWidth,
        behavior: "smooth",
      });
    };

    const interval = setInterval(slide, slideInterval);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header page-header--blank">
          <div className="page-header__bg" />
          {/* /.page-header__bg */}
        </section>
        {/* /.page-header */}
        <section className="villa-details-one">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-xl-5">
                <div className="villa-details-one__info">
                  <p className="villa-details-one__address">
                    Ideal for a family getaway
                  </p>
                  <h3 className="villa-details-one__title">The Peak Family</h3>
                </div>
              </div>
              <div className="col-lg-8 col-xl-7">
                <div className="villa-details-one__meta">
                  <div className="villa-details-one__meta__item">
                    <div className="villa-details-one__meta__icon">
                      <span className="icon-bed" />
                    </div>
                    <h5 className="villa-details-one__meta__number">
                      2 King Size
                    </h5>
                    <p className="villa-details-one__meta__name">Beds</p>
                  </div>
                  {/* meta-item */}
                  <div className="villa-details-one__meta__item">
                    <div className="villa-details-one__meta__icon">
                      <span className="icon-bath" />
                    </div>
                    <h5 className="villa-details-one__meta__number">1</h5>
                    <p className="villa-details-one__meta__name">Bathroom</p>
                  </div>
                  {/* meta-item */}
                  <div className="villa-details-one__meta__item">
                    <div className="villa-details-one__meta__icon">
                      <span className="icon-guests" />
                    </div>
                    <h5 className="villa-details-one__meta__number">4</h5>
                    <p className="villa-details-one__meta__name">Guests</p>
                  </div>
                  {/* meta-item */}
                  <div className="villa-details-one__meta__item">
                    <div className="villa-details-one__meta__icon">
                      <span className="icon-square-measument" />
                    </div>
                    <h5 className="villa-details-one__meta__number">22</h5>
                    <p className="villa-details-one__meta__name">Sqft Size</p>
                  </div>
                  {/* meta-item */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="villa-details-gallery">
          <div
            ref={galleryRef}
            style={{
              display: "flex",
              gap: "16px",
              flexWrap: "nowrap",
              whiteSpace: "nowrap",
              scrollBehavior: "smooth",
              width: "100%",
              paddingBottom: "8px",
            }}
          >
            {images.map((src, idx) => (
              <div
                className="item"
                key={src}
                style={{
                  flex: "0 0 25%",
                  maxWidth: "25%",
                  minWidth: "25%",
                }}
              >
                <div className="villa-details-gallery__item">
                  <img
                    src={src}
                    alt="villoz"
                    className="roompicheight"
                    style={{
                      display: "inline-block",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </section>
        <section className="villa-details-three">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="villa-details-three__content">
                  <h4 className="villa-details-three__content__title">
                    Overview
                  </h4>
                  <p className="villa-details-three__content__text">
                    Tailored for families or small groups, this cozy room
                    comfortably sleeps four with two-king-sized beds and a
                    bathroom fitted with a rain shower. Step onto the private
                    balcony with picturesque mountain views, ideal for
                    reconnecting with nature and loved ones.
                  </p>
                  <div className="villa-details-three__content__divider" />
                  <h4 className="villa-details-three__content__title">
                    Amenities
                  </h4>
                  <ul className="villa-details-three__lists">
                    <li>
                      <span className="fas fa-check" />
                      Air Conditioning
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Working Desk
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Wardrobe
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Wi-Fi
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Sofa
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Mosquito Net
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Rooftop Access
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Toiletries
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Balcony`
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Mountain View
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Patio
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Private Bathroom
                    </li>
                    <li>
                      <span className="fas fa-check" />
                      Rooftop Access
                    </li>
                  </ul>
                  {/* <h4 class="villa-details-three__content__title mb32">Calendar & Prices</h4>
                      <div class="villa-details-three__calender-box">
                          <div class="villoz-datepicker"></div>
                      </div> */}
                  <div className="result" />
                  {/* /.result */}
                </div>
              </div>
              <div className="col-lg-4">
                <div className="villa-details-sidebar">
                  <div className="villa-details-sidebar__booking">
                    <h4 className="villa-details-sidebar__booking__title">
                      Book Room
                    </h4>
                    <form className="villa-details-sidebar__form contact-form-validated">
                      <div className="villa-details-sidebar__control">
                        <label htmlFor="checkin">Checkin</label>
                        <input
                          className="villoz-datepicker"
                          id="checkin"
                          type="text"
                          name="checkin"
                          placeholder="Select Date"
                        />
                      </div>
                      {/* /.form__control */}
                      <div className="villa-details-sidebar__control">
                        <label htmlFor="checkout">Checkout</label>
                        <input
                          className="villoz-datepicker"
                          id="checkout"
                          type="text"
                          name="checkout"
                          placeholder="Select Date"
                        />
                      </div>
                      {/* /.form__control */}
                      <div className="villa-details-sidebar__control">
                        <label htmlFor="guests">Guests</label>
                        <select
                          name="guests"
                          className="selectpicker"
                          id="guests"
                        >
                          <option value="select">0</option>
                          <option value={1}>1</option>
                          <option value={2}>2</option>
                          <option value={3}>3</option>
                          <option value={4}>4</option>
                          <option value={5}>5</option>
                        </select>
                      </div>
                      {/* /.form__control */}
                      <a
                        href="https://live.ipms247.com/booking/book-rooms-hanthanahousekandy"
                        className="villoz-btn"
                      >
                        <i>Book Now</i>
                        <span>Book Now</span>
                      </a>
                    </form>
                    <div className="result" />
                    {/* /.result */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Peakfamily;
